/**
 * Constantes para el módulo de contratos
 */

// Configuración de paginación
export const ITEMS_PER_PAGE = 10;

// Estados de contratos
export const CONTRACT_STATES = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  WITH_SUBSCRIBERS: 'with_subscribers',
  WITHOUT_SUBSCRIBERS: 'without_subscribers',
};

// Tipos de plan
export const PLAN_TYPES = {
  REGULAR: 'regular',
  PREMIUM: 'premium',
};

// Configuración de tabs para el diálogo de edición
export const DIALOG_TABS = {
  GENERAL_DATA: 0,
  SUBSCRIBERS: 1,
  ADDITIONALS: 2,
  COUPONS: 3,
  INVOICES: 4,
  RELEASE: 5,
};

// Labels para tabs
export const TAB_LABELS = {
  [DIALOG_TABS.GENERAL_DATA]: 'DATOS GENERALES',
  [DIALOG_TABS.SUBSCRIBERS]: 'SUSCRIPTORES',
  [DIALOG_TABS.ADDITIONALS]: 'SUB-PLANES/ADICIONALES',
  [DIALOG_TABS.COUPONS]: 'CUPONES',
  [DIALOG_TABS.INVOICES]: 'FACTURAS',
  [DIALOG_TABS.RELEASE]: 'LIBERAR',
};

// Configuración de filtros
export const FILTER_CONFIG = {
  GROUP_ALL: 0,
  CONTRACT_NUMBER_DEFAULT: '0',
};

// Estados iniciales
export const INITIAL_CONTRACT_STATE = {
  uuid: '',
  contract_number: '',
  uuid_plan: '',
  uuid_group: '',
  uuid_payment_method: '',
  uuid_legal_entity: '',
  uuid_construction_type: '',
  uuid_pre_adjudication_reason: '',
  uuid_release_reason: 0,
  first_fee: '',
  request_number: '',
  by_email: false,
  private_land: false,
  is_premium: false,
  not_generate: false,
  direct_debit_enabled: false,
  direct_debit_cbu: '',
  initial_subscription_date: '',
  current_possessor_date: '',
  adjudication_date: '',
  life_insurance: '',
  construction_site_location: '',
  release_reason_obs: '',
  last_generated_fee: 0,
  is_mora_quarantine: false,
  mora_quarantine_at: '',
  mora_quarantine_reason: '',
  mora_reactivated_at: '',
  is_archived: false,
  subscribers: [],
  additionals: [],
};

// Mensajes
export const MESSAGES = {
  SUBSCRIBER_ADDED:
    "Suscriptor agregado con éxito. El contrato ahora se encontrará en 'Contratos con Suscriptor'.",
  SUBSCRIBER_REMOVED:
    "Se han eliminado todos los suscriptores. El contrato ahora se encontrará en 'Contratos sin Suscriptor'.",
  DATA_SAVED: 'Datos guardados correctamente',
  ERROR_SAVING: 'Error al guardar los datos',
  ERROR_FETCHING: 'Error al obtener los contratos',
  CONFIRM_DELETE_SUBSCRIBER: '¿Confirma que desea eliminar este suscriptor?',
  CONFIRM_DELETE_ADDITIONAL: '¿Confirma que desea eliminar este adicional?',
  CONFIRM_RELEASE: '¿Confirma que desea liberar este contrato?',
  ERROR_OCCURRED: 'Ocurrió un error',
  INVALID_DIRECT_DEBIT_CBU: 'El CBU de débito directo debe tener 22 dígitos numéricos',
  CONTRACT_RELEASED: 'Contrato liberado correctamente',
  CONTRACT_ARCHIVED: 'Contrato archivado correctamente',
  CONTRACT_MORA_ACTIVATED: 'Contrato pasado a cartera en mora correctamente',
  CONTRACT_MORA_REACTIVATED: 'Contrato reactivado desde cartera en mora correctamente',
  SUBSCRIBER_SAVED: 'Suscriptor guardado correctamente',
  SUBSCRIBER_DELETED: 'Suscriptor eliminado correctamente',
  ADDITIONAL_SAVED: 'Adicional guardado correctamente',
  ADDITIONAL_DELETED: 'Adicional eliminado correctamente',
  SELECT_SUBSCRIBER: 'Debe seleccionar un suscriptor',
  SELECT_ADDITIONAL: 'Debe seleccionar un adicional',
  COMPLETE_RELEASE_DATA: 'Debe completar el motivo y la observación',
};

// Configuración de estilos
export const RESPONSIVE_CONFIG = {
  DIALOG_WIDTH: {
    xs: '95%',
    sm: '90%',
    md: '1200px',
  },
  FORM_FIELD_WIDTH: {
    small: '250px',
    medium: '300px',
    large: '400px',
  },
};

// Colores para estados
export const STATE_COLORS = {
  SUCCESS: '#5e894f',
  WARNING: '#d44242',
  DISABLED: '#c0c0c0',
  BACKGROUND_DISABLED: '#f5f5f5',
};

export const INITIAL_CONTRACT_FILTERS = {
  groupUuid: 0,
  contractNumber: '',
  dni: '',
  name: '',
};

// Estados iniciales para suscriptores y adicionales
export const INITIAL_SUBSCRIBER_STATE = {
  uuid: '',
  subscriber: null,
  social_fee_payment: false,
  life_insurance_percentage: '',
  postage_address: false,
  mail_coupon: false,
};

export const INITIAL_ADDITIONAL_STATE = {
  uuid: '',
  additional: null,
  description: '',
  amount: '',
  current_fee: '',
  initial_fee: '',
  final_fee: '',
};
